'use client';

import { useBaseApiCall } from '@/api/factory/base/api';
import { useHandleMutationError } from '@/api/utils';
import { QUERY_KEYS } from '@/features/basket/api/query/index';
import type { Basket } from '@/features/basket/types/basket';
import { useSetCookie } from '@/hooks/use-cookies';
import { Cookie } from '@/types/storage';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface AddToCartDTO {
  productId: number;
  productQuantity: number;
}

export const useAddProductAndCreateCartMutation = () => {
  const addToCartProduct = useBaseApiCall<Basket, [AddToCartDTO]>(
    (api, product) => api.post(`basket`, product),
  );
  const handleMutationError = useHandleMutationError();
  const queryClient = useQueryClient();
  const setCookie = useSetCookie();

  return useMutation({
    mutationFn: addToCartProduct,
    onSuccess: (data) => {
      setCookie(Cookie.BASKET_ID, data.id);
      queryClient.setQueryData([QUERY_KEYS.BASKET, data.id], data);
    },
    onError: handleMutationError,
  });
};
